import HP from "../host";
import { PaginationParamsType } from "../types/common";
import { ApiService } from "./API";
const api = new ApiService(`${HP.request}://${HP.host}/api/v1`);
const InvitationService = {
  sendInvitation: async (body: object) => {
    return await api.post("/invitation/send", body);
  },
  updateStatus: async (id: string, status: string | number) => {
    return await api.put(`/invitation/update/${id}`, { status });
  },
  getAll: async (params: PaginationParamsType) => {
    return await api.get(
      `/invitation/all?page=${params.page}&per_page=${params.per_page}&query=${
        params.query || ""
      }`
    );
  },
  remove: async (id: string) => {
    return await api.delete(`/invitation/delete/${id}`);
  },
};
export default InvitationService;
